var render = function () {
  var _ref;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-button', {
    class: _vm.$style.container,
    on: {
      "click": _vm.handleClick
    }
  }, [_c('base-icon', {
    directives: [{
      name: "z-index",
      rawName: "v-z-index",
      value: 100,
      expression: "100"
    }],
    attrs: {
      "name": "basic_bar-chart"
    }
  }), _c('div', {
    class: [_vm.$style.corners, (_ref = {}, _ref[_vm.$style.visible] = _vm.isActive, _ref)]
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }